import authRoutes from './auth/routes';

export default {
  home: '/',
  auth: authRoutes,
  feedback: '/feedback',
} as const;
